import { create } from "zustand";

interface IFiltersState {
  isCollapsed: boolean;
  toggleIsCollapsed: () => void;
}

const useSidebarCollapseStore = create<IFiltersState>()(
  (set): IFiltersState => ({
    isCollapsed: false,
    toggleIsCollapsed: (): void => {
      set(
        (state): IFiltersState => ({
          ...state,
          isCollapsed: !state.isCollapsed,
        }),
      );
    },
  }),
);

export { useSidebarCollapseStore };
